import { styled } from 'styled-components';

export const StyledFieldError = styled.div`
  font-size: ${({ theme }) => theme.font.size.md}rem;
  color: ${({ theme }) => theme.colors.threshold.high};
  margin-top: ${({ theme }) => theme.spacing()}px;
  display: flex;

  svg {
    margin-right: ${({ theme }) => theme.spacing()}px;
  }
`;
